module.exports = __webpack_public_path__ + "img/eggdrop.3ab1a2c4.gif";